import type Sortable from 'sortablejs';

import type { SortableList } from 'cadenza/workbook/sortable-list/sortable-list';

/*
 * Solution is based of the RemoveOnSpill plugin from Sortablejs:
 * https://github.com/SortableJS/Sortable/tree/master/plugins
 */
export class RemoveOnSpillPlugin {
  static readonly pluginName = 'disyRemoveOnSpill';
  #sortable;

  constructor(sortable: Sortable) {
    this.#sortable = sortable;
  }

  drop(event: {
    originalEvent: TouchEvent | MouseEvent;
    sortable: Sortable;
    putSortable?: Sortable;
    activeSortable?: Sortable;
    dragEl?: Element;
  }) {
    const originalEvent = event.originalEvent;
    if (!originalEvent) {
      return;
    }
    const fromSortable = event.sortable;
    const toSortable = event.putSortable || event.activeSortable;
    const isTouchEvent = 'changedTouches' in originalEvent;
    const touch = isTouchEvent ? originalEvent.changedTouches[0] : originalEvent;
    const target = document.elementFromPoint(touch.clientX, touch.clientY);
    if (
      (fromSortable.el as SortableList).pull === 'copy' && // pull is a property of d-sortable-list: Do not spill moved elements, but only copied ones.
      toSortable &&
      !toSortable.el.contains(target)
    ) {
      this.onSpill(event.dragEl, event.putSortable);
    }
  }

  onSpill(dragElement?: Element, toSortable?: Sortable) {
    if (!dragElement || !toSortable) {
      return;
    }
    const sortable = toSortable || this.#sortable;
    /* @ts-expect-error The @types/sortablejs are incomplete. */
    sortable.captureAnimationState();
    if (dragElement.parentNode) {
      dragElement.parentNode.removeChild(dragElement);
    }
    /* @ts-expect-error The @types/sortablejs are incomplete. */
    sortable.animateAll();
  }
}
